import * as React from "react";

import { FormControl, TFormControlProps } from "kanopi-components/Input";
import { Select as Input } from "kanopi-components/Select";

import { WidthContainer } from "../../ChatFlow/WidthContainer";
import { Value } from "baseui/select";

type TSelectProps = {
  valueDisablesInput?: string[];
  size: string;
  value: string[] | string;
  options: { title: string; value: string }[];
} & TFormControlProps;

export const Select: React.FC<TSelectProps> = ({
  label,
  title,
  help,
  error,
  size,
  hideLabel,
  value,
  valueDisablesInput = [],
  options,
  ...props
}) => {
  const options_ = React.useMemo(
    () =>
      options.map((option) => {
        if (valueDisablesInput.length > 0 && value.length) {
          if (
            // If the chosen options includes a value that disables the input, disable the options
            (Array.isArray(value) &&
              value.some((item) => valueDisablesInput.includes(item))) ||
            valueDisablesInput.includes(value as string) ||
            // If the chosen options doesn't include a value that disables the input, disable the
            // value that would disable the input
            valueDisablesInput.includes(option.value)
          ) {
            return {
              ...option,
              disabled: true,
            };
          }
        }
        return option;
      }),
    [options, value]
  );

  return (
    <WidthContainer size={size}>
      <FormControl
        label={label}
        title={title}
        caption={help}
        error={error}
        hideLabel={hideLabel}
      >
        <Input
          labelKey="title"
          valueKey="value"
          size={size}
          clearable={false}
          value={value}
          options={options_}
          {...props}
        />
      </FormControl>
    </WidthContainer>
  );
};
